import { FGInput, FGInputField, FGButton, FGTypography, FGIcons, IconsLarge } from '@fg/design-system';
import { useState } from 'react';

function validateEmail(email: string) {
  var re =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}
type Props = {
  appCode: string;
  setErrorMessage: Function;
  forgotPasswordAPICall: Function;
};
export const ForgotPasswordView = ({ appCode, setErrorMessage, forgotPasswordAPICall }: Props) => {
  const id = 'sing-in-view';
  const [email, setEmail] = useState('');
  const [emailSent, setEmailSent] = useState(false);
  const handleChange = (e) => {
    setEmail(e.target.value);
  };
  const sendEmail = () => {
    const lowerCaseEmail = email.toLowerCase();
    const isValidEmail = validateEmail(email);
    if (!isValidEmail && email) {
      setErrorMessage('Please enter a valid email address.');
    } else {
      callForgotPassword(lowerCaseEmail);
      setErrorMessage('');
    }
  };
  const callForgotPassword = (lowerCaseEmail: string) => {
    const payload = {
      email: lowerCaseEmail,
      appCode: appCode,
    };
    forgotPasswordAPICall(payload).then(() => {
      setEmailSent(true);
    });
    return false;
  };
  const handleKeypress = (e) => {
    if (e.charCode === 13 && email) {
      sendEmail();
    }
  };
  return (
    <div>
      {!emailSent && (
        <div className="fg-mg--t10 fg-fxd--c tab-panel-content">
          <FGInputField id={`${id}-forget-password-field`} label="Email Address">
            <FGInput
              size="l"
              id={`${id}-forget-password-field`}
              name="email"
              value={email}
              onChange={handleChange}
              onKeyPress={handleKeypress}
              autoComplete="username"
            />
          </FGInputField>
          <div className="fg-pd--y6" style={{ display: 'inline-grid' }}>
            <FGButton className="pi-submit-email" onClick={sendEmail} disabled={!email} size="xl">
              Send me a Reset Password Email
            </FGButton>
          </div>
        </div>
      )}
      {emailSent && (
        <div
          className="fg-mg--t10 fg-fxd--c"
          style={{
            display: 'flex',
            maxWidth: '424px',
            marginLeft: 'auto',
            marginRight: 'auto',
          }}
        >
          <div className="fg-fxd--c" style={{ display: 'flex' }}>
            <FGTypography tag="h6" style="headline6">
              <div
                style={{
                  display: 'flex',
                }}
                className="fg-pd--b2 fg-ai--c fg-jc--c"
              >
                <FGIcons
                  large={IconsLarge.Check}
                  className="fg-mg--r2"
                  style={{
                    color: 'var(--fg-green-green-700)',
                  }}
                />
                Reset Password email sent.
              </div>
            </FGTypography>
            <p
              className="fg-body3-long fg-ta--c fg-mg--0"
              style={{
                color: 'var(--fg-grey-grey-700)',
              }}
            >
              If you don't receive the email in 10 minutes, please check your spam folder or try again.
            </p>

            <div
              className="fg-pd--y10"
              style={{
                display: 'inline-grid',
              }}
            >
              <FGButton size="xl" variant="secondary" onClick={sendEmail}>
                Resend Link
              </FGButton>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
